<template>
    <project ref="project"
        classContainer="dick-container dick-2" 
        classOverlay="overlay-dick"
        :bubbleOneData="this.bubbleOneData"
        :bubbleTwoData="this.bubbleTwoData"
        :previewOneData="this.previewOneData"
        :previewSliderOneData="this.previewSliderOneData"
        :previewSliderTwoData="this.previewSliderTwoData"/>
    
    <!--<img class="example" src="@/assets/dick/home2.jpg" />-->
    
</template>

<script>
    import Project from '../../Project.vue'

    export default {
        components: {
                Project 
            
        }, 
        
        name: "dickTwo",
        data: () => ({
            bubbleOneData: {
                class:"bubble-one-dick-1",
                text: "<p>"+
                            "We cast semi-pro athletes for a series<br/>"+ 
                            "of in-studio and on-location<br/>"+
                            "photoshoots. From the amount of<br/>" + 
                            "talent (including a dog), locations,<br/>"+
                            "sets, wardrobe, assistants, etc it was<br/>"+
                            "by far the largest creative operation<br/>"+
                            "I’d ever overseen. And I’m proud to<br/>"+
                            "say everything turned out great–these<br/>"+
                            "assets were a huge part of the new<br/>"+
                            "site’s success.<br/>"+
                        "</p>",
                title:"Branding & Redesign",
                fontSizeInnerText:"0.79rem",
                marginLeft:"-2.4rem",
                fontSize:"2rem", 
                marginTop:"4%",
                color:"#08483d",
                colorOverlay:"#fff",
                colorText:"#08483d",
                textSlice:5
            },
            bubbleTwoData:{
                class: "bubble-two-dick-1",
                text:   "<p>BRANDING</p>"+
                        "<p>CREATIVE DIRECTION</p><br/>"+
                        "<p>CASTING & PHOTOSHOOT ART DIRECTION</p><br/>"+
                        "<p>DIGITAL & UI DESIGN</p>",
                color:"#08483d",
                colorOverlay:"#12a58d",
                colorText:"#fff"
            },
            previewOneData:{
                class:"dick-2-preview",
                img:"assets/dick/dick2_slide_1.jpg",
                upDown:false,
                forward:false,
                isBrik: false
            },
            previewSliderOneData:{
                class: "dick-2-video-1",
                images:['assets/dick/dick1/2_Dicks_Screen_L_1_L.jpg', 'assets/dick/dick1/2_Dicks_Screen_L_2_L.jpg', 'assets/dick/dick1/2_Dicks_Screen_L_3_L.jpg']
            },
            previewSliderTwoData:{
                class: "dick-2-video-2",
                images:['assets/dick/dick1/2_Dicks_Screen_1_R.jpg', 'assets/dick/dick1/2_Dicks_Screen_2_R.jpg', 'assets/dick/dick1/2_Dicks_Screen_3_R.jpg']
            },
        }),
        methods: {
            openNonAnimated(){
                this.$refs.project.openNonAnimated()
            },
            open(onOpened){
                this.$refs.project.open(onOpened)
            },
            close(){
                this.$refs.project.close()
            },
            pause(){
                this.$refs.project.pause()
            },
            play(){
                this.$refs.project.play()
            },
            isHovering(){
                return this.$refs.project.isHovering
            }
        },
    }
</script>

<style>
    .dick-2-preview{
        width: 38vw;
        height: 29.5vw;
        top: 20%;
        left: 32%;
    }

    .dick-2-video-2{
        top: 25.5% !important;
        left: 67% !important;
        width: 17.5vw !important;
        height: 11vw !important;
    }

    .dick-2-video-1{
        top: 54% !important;
        left: 15.5% !important;
        width: 20.5vw !important;
        height: 11.5vw !important;
    }

    .bubble-two-dick-2{
        left: 27%;
        top: 69.5%;
        height: 13vw;
        width: 13vw;
    }
    .bubble-one-dick-2{
        left: 69%;
        top: 58.75%;
        height: 17.5vw;
        width: 17.5vw;
    }
    .dick2-container{
        height: 100%;
        width: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 0;
        left: 0;
    }

    @media (orientation: portrait) {
        .bubble-one-dick-2 {
            top: 60.75%;
            height: 57vw;
            width: 57vw;
            left: 40%;
        }
        .bubble-two-dick-2{
            top: 20.5%;
            height: 42.5vw;
            width: 42.5vw;
        }

        .dick-2-preview{
            width: 57vw;
            height: 44.25vw;
            top: 37%;
            left: 21%;
        }

        .dick-2-video-2{
            top: 54.5% !important;
            
            left: 7.5% !important;
            width: 27.75vw !important;
            height: 16.5vw !important;
        }

        .dick-2-video-1{
            top: 36% !important;
            left: 65% !important;
            width: 26.25vw !important;
            height: 16.5vw !important;
        }
    }

 
</style>